/* eslint-disable @typescript-eslint/no-explicit-any */

import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { createUploadLink } from 'apollo-upload-client';
import 'cross-fetch/polyfill';
export default new ApolloClient<InMemoryCache>({
  link: createUploadLink({ uri: `${(window as any).$store.backend}/graphql` }),
  cache: new InMemoryCache() as any,
});
